var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxesStacked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 288H160V384L128 362.75L96 384V288H32C14.398 288 0 302.4 0 320V480C0 497.6 14.398 512 32 512H224C241.602 512 256 497.6 256 480V320C256 302.4 241.602 288 224 288ZM192 224H384C401.602 224 416 209.6 416 192V32C416 14.4 401.602 0 384 0H320V96L288 74.75L256 96V0H192C174.398 0 160 14.4 160 32V192C160 209.6 174.398 224 192 224ZM544 288H480V384L448 362.75L416 384V288H352C334.398 288 320 302.4 320 320V480C320 497.6 334.398 512 352 512H544C561.602 512 576 497.6 576 480V320C576 302.4 561.602 288 544 288Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxesStacked);
export default __webpack_public_path__ + "static/media/boxes-stacked.10ecb78fdca815836c9e61f587ab1d3d.svg";
export { ForwardRef as ReactComponent };